"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveUninstallFeedback = exports.getPauseProgress = exports.exportCampaigns = exports.getUninstallStatus = exports.markNotificationAsRead = exports.shopNotifies = exports.getShopStorage = exports.setShopStorage = exports.setUpsellSettings = exports.setGiftSettings = exports.setCrossSellSettings = exports.setSalesBadgeSettings = exports.setBogoFabSettings = exports.setBogoModalSettings = exports.setBundleEmbedSettings = exports.setComingSoonClicked = exports.setDiscountProgressBarSettings = exports.setShippingEmbedSettings = exports.setInventoryEmbedSettings = exports.setcartEmbedSettings = exports.setproductEmbedSettings = exports.setProductCountdownSettings = exports.changeDiscountNotes = exports.setWeeklyDigest = exports.emailUnsubscribe = exports.getShopLocales = exports.getVendorCounts = exports.getVendors = exports.getVariantMetafields = exports.getProductTagCounts = exports.getProductTags = exports.getProductTypeCounts = exports.getSampleProducts = exports.getProductTypes = exports.getThemeEnabled = exports.hasThemeAccess = exports.hasCustomerAccess = exports.getB2bSignals = exports.getShopInfo = exports.shopIsInstalled = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Check shop exists and installed
*/
const shopIsInstalled = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/isInstalled`, method: 'get',
        params
    });
};
exports.shopIsInstalled = shopIsInstalled;
/**
* @summary Get shop info
*/
const getShopInfo = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/info`, method: 'get'
    });
};
exports.getShopInfo = getShopInfo;
/**
* @summary Smart B2B detection signals (product costs + customer segments)
*/
const getB2bSignals = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/b2b-signals`, method: 'get'
    });
};
exports.getB2bSignals = getB2bSignals;
/**
* @summary has customer access
*/
const hasCustomerAccess = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/has_customer_access`, method: 'get'
    });
};
exports.hasCustomerAccess = hasCustomerAccess;
/**
* @summary has theme access
*/
const hasThemeAccess = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/has_theme_access`, method: 'get'
    });
};
exports.hasThemeAccess = hasThemeAccess;
/**
* @summary Get Theme Enabled
*/
const getThemeEnabled = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/themeEnabled`, method: 'get'
    });
};
exports.getThemeEnabled = getThemeEnabled;
/**
* @summary Get list of product types
*/
const getProductTypes = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productTypes`, method: 'get'
    });
};
exports.getProductTypes = getProductTypes;
/**
* @summary A few real ACTIVE products (with image) from the local read model, for the widget previews. Empty list when the read model is not ready.
*/
const getSampleProducts = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/sampleProducts`, method: 'get',
        params
    });
};
exports.getSampleProducts = getSampleProducts;
/**
* @summary Per-product-type ACTIVE product counts. `counts: null` means the shop cannot serve this locally yet — the picker must show a loading state, never a 0.
*/
const getProductTypeCounts = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productTypes/counts`, method: 'get'
    });
};
exports.getProductTypeCounts = getProductTypeCounts;
/**
* @summary Get list of Product Tags
*/
const getProductTags = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productTags`, method: 'get'
    });
};
exports.getProductTags = getProductTags;
/**
* @summary Per-tag ACTIVE product counts. `counts: null` means the shop cannot serve this locally yet — the picker must show a loading state, never a 0.
*/
const getProductTagCounts = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productTags/counts`, method: 'get'
    });
};
exports.getProductTagCounts = getProductTagCounts;
/**
* @summary Get list of variant (PRODUCTVARIANT) metafield definitions
*/
const getVariantMetafields = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/variant-metafields`, method: 'get'
    });
};
exports.getVariantMetafields = getVariantMetafields;
/**
* @summary Get list Vendors
*/
const getVendors = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/vendors`, method: 'get'
    });
};
exports.getVendors = getVendors;
/**
* @summary Per-vendor ACTIVE product counts. `counts: null` means the shop cannot serve this locally yet — the picker must show a loading state, never a 0.
*/
const getVendorCounts = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/vendors/counts`, method: 'get'
    });
};
exports.getVendorCounts = getVendorCounts;
/**
* @summary Get the shop's published languages (Settings > Languages), fetched live from Shopify
*/
const getShopLocales = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/locales`, method: 'get'
    });
};
exports.getShopLocales = getShopLocales;
/**
* @summary One-click unsubscribe from weekly digest (public, no auth)
*/
const emailUnsubscribe = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/email/unsubscribe`, method: 'get',
        params
    });
};
exports.emailUnsubscribe = emailUnsubscribe;
/**
* @summary Enable or disable weekly analytics digest email
*/
const setWeeklyDigest = (setWeeklyDigestBody) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/weeklyDigest`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: setWeeklyDigestBody
    });
};
exports.setWeeklyDigest = setWeeklyDigest;
/**
* @summary Change discount notes
*/
const changeDiscountNotes = (changeDiscountNotesBody) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/discountNotes`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: changeDiscountNotesBody
    });
};
exports.changeDiscountNotes = changeDiscountNotes;
/**
* @summary Set product discount settings
*/
const setProductCountdownSettings = (productCountdownSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productCountdownSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: productCountdownSettingsDto
    });
};
exports.setProductCountdownSettings = setProductCountdownSettings;
/**
* @summary Set product discount settings
*/
const setproductEmbedSettings = (productEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/productEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: productEmbedSettingsDto
    });
};
exports.setproductEmbedSettings = setproductEmbedSettings;
/**
* @summary Set product discount settings
*/
const setcartEmbedSettings = (cartEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/cartEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: cartEmbedSettingsDto
    });
};
exports.setcartEmbedSettings = setcartEmbedSettings;
/**
* @summary set Inventory Embed Settings
*/
const setInventoryEmbedSettings = (inventoryEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/InventoryEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: inventoryEmbedSettingsDto
    });
};
exports.setInventoryEmbedSettings = setInventoryEmbedSettings;
/**
* @summary Set shipping embed settings
*/
const setShippingEmbedSettings = (shippingEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/shippingEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: shippingEmbedSettingsDto
    });
};
exports.setShippingEmbedSettings = setShippingEmbedSettings;
/**
* @summary Set discount progress bar widget settings
*/
const setDiscountProgressBarSettings = (discountProgressBarSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/discountProgressBarSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: discountProgressBarSettingsDto
    });
};
exports.setDiscountProgressBarSettings = setDiscountProgressBarSettings;
/**
* @summary Set ComingSoon
*/
const setComingSoonClicked = (setComingSoonClickedDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/setComingSoonClicked`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: setComingSoonClickedDto
    });
};
exports.setComingSoonClicked = setComingSoonClicked;
/**
* @summary set Bundle Embed Settings
*/
const setBundleEmbedSettings = (bundleEmbedSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/BundleEmbedSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bundleEmbedSettingsDto
    });
};
exports.setBundleEmbedSettings = setBundleEmbedSettings;
/**
* @summary set Bogo Modal Settings
*/
const setBogoModalSettings = (bogoModalSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/BogoModalSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bogoModalSettingsDto
    });
};
exports.setBogoModalSettings = setBogoModalSettings;
/**
* @summary set Bogo FAB Settings
*/
const setBogoFabSettings = (bogoFabSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/BogoFabSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: bogoFabSettingsDto
    });
};
exports.setBogoFabSettings = setBogoFabSettings;
/**
* @summary set Sales Badge Settings
*/
const setSalesBadgeSettings = (salesBadgeSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/SalesBadgeSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: salesBadgeSettingsDto
    });
};
exports.setSalesBadgeSettings = setSalesBadgeSettings;
/**
* @summary set Cross Sell Settings
*/
const setCrossSellSettings = (crossSellSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/CrossSellSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: crossSellSettingsDto
    });
};
exports.setCrossSellSettings = setCrossSellSettings;
/**
* @summary set Free Gift widget Settings
*/
const setGiftSettings = (giftSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/GiftSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: giftSettingsDto
    });
};
exports.setGiftSettings = setGiftSettings;
/**
* @summary set Upsell (Upgrade offer) widget Settings
*/
const setUpsellSettings = (upsellSettingsDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/UpsellSettings`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: upsellSettingsDto
    });
};
exports.setUpsellSettings = setUpsellSettings;
/**
* @summary Set list of key value storage
*/
const setShopStorage = (shopStorageDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/storage`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: shopStorageDto
    });
};
exports.setShopStorage = setShopStorage;
/**
* @summary get list of key value storage with filter
*/
const getShopStorage = (params) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/storage`, method: 'get',
        params
    });
};
exports.getShopStorage = getShopStorage;
/**
* @summary shop notifies
*/
const shopNotifies = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/shop_notifies`, method: 'get'
    });
};
exports.shopNotifies = shopNotifies;
/**
* @summary Mark a notification as read
*/
const markNotificationAsRead = (markNotificationAsReadBody) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/mark_notification_as_read`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: markNotificationAsReadBody
    });
};
exports.markNotificationAsRead = markNotificationAsRead;
/**
* @summary Get safe-uninstall status for the shop
*/
const getUninstallStatus = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/uninstall-status`, method: 'get'
    });
};
exports.getUninstallStatus = getUninstallStatus;
/**
* @summary Export campaign history as encoded payload
*/
const exportCampaigns = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/export-campaigns`, method: 'get'
    });
};
exports.exportCampaigns = exportCampaigns;
/**
* @summary Returns count of campaigns still being deactivated — poll until safe=true
*/
const getPauseProgress = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/pause-progress`, method: 'get'
    });
};
exports.getPauseProgress = getPauseProgress;
/**
* @summary Save uninstall feedback reason and note
*/
const saveUninstallFeedback = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/shops/uninstall-feedback`, method: 'post'
    });
};
exports.saveUninstallFeedback = saveUninstallFeedback;
